
export default class Route {
  public static get selfServiceStore(): string {
    return '/self-service-store'
  }

  public static get NetWorksLandingPageRoute(): string {
    return 'Networks'
  }
  public static get internationalStore(): string {
    return 'int-store-landing-page'
  }

  public static get CrossConnectPageRoute(): string {
    return 'cross-connect'
  }

  public static get orderSummaryPageRoute(): string {
    return 'order-summary'
  }

  public static get CheckoutPageRoute(): string {
    return 'checkout'
  }

  public static get OrderSubmissionPageRoute(): string {
    return 'order-submission'
  }
  
  public static unifiedTrackingPath(): string {
    return '/tracking/requests'
  }
  public static get NotFound(): string {
    return 'not-found'
  }
  public static get NotAuthorised(): string {
    return 'not-authorised'
  }

  public static get savedCardRoute(): string {
    return 'saved-cart'
  }

  public static get manageSubscriptionRoute(): string {
    return 'manage-subscription'
  }

  public static get cartPageRoute(): string {
    return 'cart'
  }
  public static get MSPEXLandingPageRoute(): string {
    return 'saas-mp'
  }



}
